<section class="flex flex-column gap-3">
  <div>
    <h1 class="text-2xl font-semibold text-color m-0 mb-2">Calculadora</h1>
    <p class="m-0 text-color-secondary">
      Sumá a todos los presentes de este domingo e informalos.
    </p>
  </div>

  @if (cargando()) {
    <app-skeleton-block variant="form" [rows]="5" />
  } @else if (errorDom()) {
    <div class="flex flex-column align-items-start gap-3">
      <p class="m-0">{{ errorDom() }}</p>
      <p-button type="button" label="Reintentar" [outlined]="true" (onClick)="cargarDomingo()" />
    </div>
  } @else {
    <div class="contador__panel flex flex-column align-items-center gap-3">
      @if (fechaVisible()) {
        <p class="m-0 text-color-secondary">Domingo {{ fechaVisible() }}</p>
      }

      <div class="contador__historial w-full">
        <p-table
          [value]="informes()"
          [loading]="cargandoInformes()"
          [showLoader]="informes().length > 0"
          [rowHover]="true"
          styleClass="p-datatable-sm"
        >
          <ng-template #header>
            <tr>
              <th>Usuario</th>
              <th>Hora</th>
              <th class="text-right">Cantidad</th>
            </tr>
          </ng-template>
          <ng-template #body let-fila>
            <tr>
              <td>{{ fila.usuario }}</td>
              <td>{{ fila.horario | date: 'HH:mm' }}</td>
              <td class="text-right">{{ fila.cantidad }}</td>
            </tr>
          </ng-template>
          <ng-template #loadingbody>
            @if (informes().length === 0) {
              @for (item of skeletonRows; track item) {
                <tr>
                  <td class="py-2"><p-skeleton height="1rem" /></td>
                  <td class="py-2"><p-skeleton height="1rem" /></td>
                  <td class="py-2"><p-skeleton height="1rem" /></td>
                </tr>
              }
            }
          </ng-template>
          <ng-template #emptymessage>
            <tr>
              <td colspan="3">Nadie informó este domingo todavía.</td>
            </tr>
          </ng-template>
        </p-table>
        @if (errorInformes()) {
          <p class="m-0 mt-2 text-sm">{{ errorInformes() }}</p>
        }
      </div>

      <p class="m-0 text-color-secondary">Conteo total</p>
      <p class="contador__total m-0" aria-live="polite">{{ total() }}</p>

      <div class="flex flex-column gap-2 w-full">
        @for (paso of pasos; track paso) {
          <p-button
            type="button"
            [label]="'+' + paso"
            [outlined]="true"
            size="large"
            [fluid]="true"
            [disabled]="enviando()"
            (onClick)="sumar(paso)"
          />
        }
        <p-button
          type="button"
          label="-1"
          severity="secondary"
          size="large"
          [fluid]="true"
          [disabled]="enviando() || total() === 0"
          (onClick)="sumar(-1)"
        />
        <p-button
          type="button"
          label="Enviar"
          icon="pi pi-send"
          size="large"
          [fluid]="true"
          [loading]="enviando()"
          [disabled]="enviando() || total() === 0"
          (onClick)="enviar()"
        />
      </div>
    </div>
  }
</section>
